import { AntdTable, Text } from '@agro-club/agroclub-shared'
import { FIVE_ITEM_PAGE_SIZE } from 'modules/constants'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { Export, ExportDealsTotals, ExportDealType } from 'modules/domain/export/types'
import { endpoints } from 'modules/endpoints'
import formatPrice from 'modules/utils/numbers/formatPrice'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import useColumns from './useColumns'

type Props = {
  exportData: Export
}

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const DealsTable: FC<Props> = ({ exportData }) => {
  const { t } = useTranslation('export')
  const [progress, deals] = useSingleEntity<ExportDealType[]>(endpoints.exportDeals(exportData.id))
  const [quantityColsSumProgress, quantityColsSum] = useSingleEntity<ExportDealsTotals | undefined>(
    endpoints.exportDealsTotals(exportData.id),
  )

  const columns = useColumns(quantityColsSumProgress, quantityColsSum)
  const footer = () => (
    <Footer>
      <Text typography="bodyMedium">{t('averagePrice')}</Text>
      &nbsp;
      <Text typography="accentMedium">{formatPrice(exportData.deal_weighted_avg_kg_price, true)}</Text>
    </Footer>
  )
  return (
    <AntdTable
      columns={columns}
      data={deals ?? []}
      progress={progress}
      rowKey="id"
      footer={footer}
      pagination={{ pageSize: FIVE_ITEM_PAGE_SIZE, size: 'small', showTotal: undefined }}
    />
  )
}
